import { Component, ElementRef, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Utils } from "../../../../../shared/utils/Utils";
import jsPDF from "jspdf";
import { Ruta, RutasService } from "../../../../../shared/services/ruta.service";
import { DataService } from "../../../../../shared/services/municipios.service";
declare var require;
const Swal = require("sweetalert2");

@Component({
  selector: "app-rutas-inactivas",
  templateUrl: "./rutas-inactivas.component.html",
  styleUrls: ["./rutas-inactivas.component.scss"],
})
export class RutasInactivasComponent {


  @ViewChild("inputOrigen") inputOrigen!: ElementRef;

  pageSize1: number = 5;
  page1: number = 1;
  totalItems: number;
  editMode: boolean;
  rutas: Ruta[] = [];
  rutaForm: FormGroup;
  municipios: any[];
  public searchText: string = "";
  filteredTableItems: Ruta[];
  
  constructor(
    private rutasService: RutasService,
    private modalService: NgbModal,
    private fb: FormBuilder,
    private dataService: DataService
  ) {}

  ngOnInit(): void {
    this.listarRutas();
    this.cargarMunicipios();
    this.inicializarFormulario();
  }

  private cargarMunicipios(): void {
    this.dataService.getDatos().subscribe({
      next: (data) => this.municipios = data,
      error: (error) => console.error("Error al obtener municipios:", error),
    });
  }

  private inicializarFormulario(): void {
    this.rutaForm = this.fb.group({
      origen: [null],
      destino: [null],
      nombre: [null],
      ruta: [null],
      estado: ["1"],
    });
  }


  listarRutas(): void {
    this.rutasService.getRutasInactivas().subscribe({
      next: (data) => {
        this.rutas = data;
        if (this.rutas.length === 0) {
          console.warn("🚫 No hay marcas registradas.");
        }
      },
      error: (err) => {
        console.error("❌ Error cargando marcas:", err);
      },
    });
  }

  private cerrarModalYRecargar() {
    this.modalService.dismissAll(); // Cierra el modal
    this.listarRutas(); // Recarga las tarjetas para la placa actual
  }

  actualizarEstadoRutaActivar(id: any): void {
    Swal.fire({
      title: "ACTIVAR",
      text: `¿Desea activar la ruta con ID: ${id}?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, activar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        this.rutasService.activarRuta(id).subscribe({
          next: () => {
            Swal.fire({
              icon: "success",
              title: "Ruta activada correctamente",
              confirmButtonText: "Aceptar",
            });

            this.cerrarModalYRecargar();
          },
          error: (error) => {
            const mensaje = error?.error?.message || "No se pudo activar la ruta";
            Swal.fire({
              icon: "error",
              title: "Error al activar",
              text: mensaje,
              confirmButtonText: "Aceptar",
            });
            console.error("Error al activar ruta:", error);
          },
        });
      }
    });
  }

  exportToPDF(tableId: string, nameFile: string, titleFile: string) {
    Utils.exportToPDF(tableId, nameFile, titleFile);
  }

  exportarExcel(tableId: string, nameFile: string) {
    Utils.exportVisibleTableToExcel(tableId, nameFile);
  }

  ngOnDestroy() {
  }

    filterData() {
    const search = this.searchText.trim().toLowerCase();

    if (!search) {
      this.filteredTableItems = [...this.rutas]; // Mostrar todos si no hay búsqueda
    } else {
      this.filteredTableItems = this.rutas.filter((item) => {
        return (
          item.nombre?.toLowerCase().includes(search) ||
          item.ruta?.toLowerCase().includes(search) 

        );
      });
    }

    this.page1 = 1; // Reiniciar a la primera página
  }
}
